export default "__VITE_ASSET__DQaQqEJo__"